import React, { useEffect, useState } from "react";
import { getAxiosHeaders, orderStatusOptions, goBack } from "../../../utils/Utils";
import { Link } from "react-router-dom";
import {
  Icon,
  Button
} from "../../../components/Component";
import { baseURLs } from '../../../utils/Constants';
import { 
  Alert,
  UncontrolledDropdown, 
  Dropdown, DropdownToggle, 
  DropdownMenu, 
  DropdownItem, 
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner } from "reactstrap";
import axios from 'axios';
import moment from "moment";
import DatePicker from "react-datepicker";
import { Input, Select, Checkbox, Form, Empty } from 'antd';
import {
  AlertModal,
  InfoModal,
  SuccessModal,
  LoadingModal
} from "../AlertModals";

const Footer = ({ history, orderInfo, setOrderInfo, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState("");

  const [activeModal, setActiveModal] = useState(null);
  
  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const deleteOrder = () => {
    setErrorMessage("");
    toggleModal('loadingModal');

    axios.delete(baseURLs.API_URL + "/purchase-orders/by-ids", {
      headers: getAxiosHeaders().headers,
      data: {
        business_id: orderInfo.business_id,
        orders: JSON.stringify([orderInfo.order_id]),
      }
    })
    .then((response) => {
      let responseInfo = response.data;
      let failedIDs = responseInfo.data.failed_order_ids;

      if(failedIDs.length === 0){
        toggleModal('successModal');
        setTimeout(() => {
          goBack({history, link: `/purchase-orders/b/${orderInfo.business_id}`})
        }, 2000);

      }  else {
        setErrorMessage(`Error deleting order. Try again`);
        toggleModal('deleteModal');
      }

    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        toggleModal('deleteModal');
      }catch(e){
        setErrorMessage("Error: Could not connect to server");
        toggleModal('deleteModal');
      } 
    });
  }

  
  return (
    <div className="fm-footer">
      <div className="fm-action">
        <ul className="d-flex g-3 justify-content-center">
          <li>
            {
              orderInfo.order_status === 'delivered' ?
              <button className="btn btn-lg btn-danger" onClick={() => toggleModal("deleteModal")}>
                <em className="icon ni ni-trash"></em>
                <span>Delete Order</span>
              </button>
              :
              <Link to={`${process.env.PUBLIC_URL}/purchase-orders/b/${orderInfo.business_id}/edit/${orderInfo.order_id}`}>
                <button className="btn btn-lg btn-primary">
                  <em className="icon ni ni-edit-alt"></em>
                  <span>Edit</span>
                </button>
              </Link>
            }
          </li>
          
          <li>
            <UncontrolledDropdown>
              <DropdownToggle className="dropdown-toggle btn btn-lg btn-outline-light" color="none">
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu end>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem tag="a" className="pointer-cursor" onClick={() => toggleModal("orderLogsModal")}>
                      <Icon name="list-thumb"></Icon>
                      <span>Order Logs</span>
                    </DropdownItem>
                  </li> 
                  {
                    orderInfo.has_supplier === 'yes' &&
                    <>
                      <li>
                        <DropdownItem tag="a" className="pointer-cursor" onClick={() => toggleModal("paymentLogsModal")}>
                          <Icon name="list"></Icon>
                          <span>Payment Logs</span>
                        </DropdownItem>
                      </li>                
                      <li className="divider"></li>
                    </>
                  }
                  <li>
                    <DropdownItem tag="a" className="pointer-cursor text-danger" onClick={() => toggleModal("deleteModal")}>
                      <Icon name="trash"></Icon>
                      <span>Delete Order</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      </div>


      {/* delete modal */}
      {
        activeModal === "deleteModal" &&
        <AlertModal 
          index="delete"
          showModal={true} 
          toggleModal={() => toggleModal('deleteModal')}
          headerText={`Delete this Order?`}
          descriptionText={`Are you sure you want to delete this purchase order? This action can not be reverted.`}
          leftButtonText={`Delete`}
          leftButtonOnClick={deleteOrder} />
      
      }

      
      {/* order logs modal */}
      {
        activeModal === "orderLogsModal" &&
        <Modal backdrop="static" isOpen={true} id="order-logs-modal">
          <ModalHeader
            toggle={() => toggleModal('orderLogsModal')}
            close={
              <button className="close" onClick={() => toggleModal('orderLogsModal')}>
                <Icon name="cross" />
              </button>
            } >
            Order Logs
          </ModalHeader>
          <ModalBody className="modal-body-md">
            <ul className="timeline-list">
              {orderInfo.order_log.map((log, index) => {
                let icon = <Icon name="clock" className="fs-20px px-1"></Icon>;
                let status = "Reviewing";

                switch (log.status) {
                  case 'reviewing':
                    status = "Reviewing";
                    icon = <Icon name="cart" className="fs-20px px-1"></Icon>;
                    break;
                
                  case 'pending_delivery':
                    status = "Pending Delivery";
                    icon = <Icon name="package" className="fs-20px px-1"></Icon>;
                    break;
                
                  case 'delivered':
                    status = "Delivered";
                    icon = <Icon name="check-c" className="fs-20px px-1"></Icon>;
                    break;
                  
                  default:
                    status = "Reviewing";
                    break;
                }

                return (
                  <li className="timeline-item" key={index}>
                    <div className={`timeline-status bg-primary ${orderInfo.order_log.length - 1 === index ? "is-outline" : ""}`}></div>
                    <div className="timeline-data">
                      <h6 className="timeline-title text-primary">{icon} {status}</h6>
                      <div className="timeline-des">
                        <p>Notes: <b>{log.notes}</b></p>
                        <p className="fs-12px">Updated By: <b>{log.updated_by}</b></p>
                        <span className="time"><Icon name="clock"></Icon> {moment(log.updated_at).format("Do MMM YYYY, hh:mm a")}</span>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </ModalBody>
        </Modal>
      }


      {/* payment logs modal */}
      {
        activeModal === "paymentLogsModal" &&
        <Modal backdrop="static" isOpen={true} id="payment-logs-modal">
          <ModalHeader
            toggle={() => toggleModal('paymentLogsModal')}
            close={
              <button className="close" onClick={() => toggleModal('paymentLogsModal')}>
                <Icon name="cross" />
              </button>
            } >
            Payment Logs
          </ModalHeader>
          <ModalBody className="modal-body-md">
            {
              orderInfo.payment_log.length === 0 ?
              <div className="text-center m-5">
                <div className="price-plan-media"><Empty image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" imageStyle={{height: 60}} description={false} /></div>
                <div className="price-plan-info">
                  <h5 className="title fw-normal">No payment logs</h5>
                  <span>Payments made on this purchase order will show here.</span>
                </div>
              </div>
              :
              <ul className="timeline-list">
                {orderInfo.payment_log.map((log, index) => {
                  return (
                    <li className="timeline-item" key={index}>
                      <div className={`timeline-status bg-primary ${index === 0 ? "is-outline" : ""}`}></div>
                      <div className="timeline-data">
                        <h6 className="timeline-title text-primary">Made payment of <small>{orderInfo.currency}</small> {log.amount_paid}</h6>
                        <div className="timeline-des">
                          <p>Payment Type: <b className="text-capitalize">{log.payment_type}</b></p>
                          <p>Balance Due: <b><small>{orderInfo.currency}</small> {log.balance_remaining}</b></p>
                          <p className="fs-12px">Updated By: <b>{log.updated_by}</b></p>
                          <span className="time"><Icon name="clock"></Icon> {moment(log.created_at).format("Do MMM YYYY, hh:mm a")}</span>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            }
          </ModalBody>
        </Modal>
      }

      {/* Loading modal */}
      {
        activeModal === "loadingModal" &&
        <LoadingModal 
          showModal={true}
          toggleModal={() => toggleModal('loadingModal')}
          headerText={`Deleting...`}
          descriptionText={`Please wait while this purchase order is being deleted...`} />
      }
      

      {/* success modal */}
      {
        activeModal === "successModal" &&
        <SuccessModal 
          showModal={true}
          toggleModal={() => toggleModal('successModal')}
          headerText={'Deleted'}
          descriptionText={'The purchase order has been deleted successfully'} />
      }

    </div>
  );
};


export default Footer;